<script lang="ts">
  import { gallery } from '../lib/gallery.svelte';

  // Touch devices "swipe"; pointer devices "scroll".
  const isTouch =
    typeof matchMedia !== 'undefined' && matchMedia('(pointer: coarse)').matches;
  const label = isTouch ? 'Swipe for more' : 'Scroll for more';

  // Only useful when there's more than one photo to move between.
  const visible = $derived(
    gallery.showHint && !!gallery.current && !gallery.panelOpen && gallery.photos.length > 1,
  );
</script>

{#if visible}
  <div class="hint" aria-hidden="true">
    <span class="label">{label}</span>
    <span class="chev"></span>
  </div>
{/if}

<style>
  .hint {
    position: fixed;
    left: 50%;
    bottom: max(22px, calc(env(safe-area-inset-bottom) + 14px));
    transform: translateX(-50%);
    z-index: 15;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.9);
    text-shadow: 0 1px 12px rgba(0, 0, 0, 0.7);
    animation: fade-in 0.6s var(--ease) both;
  }

  .label {
    font-size: 0.82rem;
    letter-spacing: 0.04em;
  }

  /* A downward chevron drawn from two borders. */
  .chev {
    width: 11px;
    height: 11px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg);
    animation: nudge 1.6s var(--ease) infinite;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes nudge {
    0%,
    100% {
      transform: rotate(45deg) translate(0, 0);
      opacity: 0.6;
    }
    50% {
      transform: rotate(45deg) translate(3px, 3px);
      opacity: 1;
    }
  }
</style>
